import { useCallback, useSyncExternalStore } from "react";
import { receiptStore } from "./index";
import type { Receipt, ReceiptStore } from "./types";

function getSnapshot(): Receipt[] {
  return receiptStore.list();
}

// localStorage is client-only — return a stable empty array during SSR/non-DOM.
const SERVER_SNAPSHOT: Receipt[] = [];
function getServerSnapshot(): Receipt[] {
  return SERVER_SNAPSHOT;
}

function subscribe(listener: () => void): () => void {
  return receiptStore.subscribe(listener);
}

export interface UseReceiptsResult {
  receipts: Receipt[];
  add: ReceiptStore["add"];
  remove: ReceiptStore["remove"];
  link: ReceiptStore["link"];
  refreshUrl: ReceiptStore["refreshUrl"];
  getByExpense(id: string): Receipt | undefined;
  getByInvoice(id: string): Receipt | undefined;
}

export function useReceipts(): UseReceiptsResult {
  const receipts = useSyncExternalStore(
    subscribe,
    getSnapshot,
    getServerSnapshot,
  );

  const getByExpense = useCallback(
    (id: string): Receipt | undefined =>
      receipts.find((r) => r.linkedExpenseId === id),
    [receipts],
  );

  const getByInvoice = useCallback(
    (id: string): Receipt | undefined =>
      receipts.find((r) => r.linkedInvoiceId === id),
    [receipts],
  );

  return {
    receipts,
    add: receiptStore.add.bind(receiptStore),
    remove: receiptStore.remove.bind(receiptStore),
    link: receiptStore.link.bind(receiptStore),
    refreshUrl: receiptStore.refreshUrl.bind(receiptStore),
    getByExpense,
    getByInvoice,
  };
}
